import React from 'react';
import { useGetSubscriptionPackagesQuery } from '../../store/api/landingApi';
import { Link, useSearchParams } from 'react-router-dom';
import PageLoader from '../../components/PageLoader';

const Subscription = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('user_id');
  const language = searchParams.get('language') || 'en';
  
  const { data, isLoading, isError } = useGetSubscriptionPackagesQuery({ 
    user_id: userId,
    language: language
  });

  if (isLoading) return <PageLoader />;
  if (isError) return <div className="text-center p-5">Error loading packages</div>;

  const { packages, user } = data?.data || {};

  const topTitle = language === 'ar' ? "النسخة المميزة" : "Premium Version";
  const topDesc = language === 'ar' ? "تمتع بتجربة فريدة مع تطبيق فسيلة" : "Enjoy a unique experience with Fesilah App.";
  const featureTitle = language === 'ar' ? "استخدم جميع ميزات فسيلة" : "Get Access to all Fesilah features";
  const subscribeText = language === 'ar' ? "اشتراك" : "Subscribe";

  const renderPackageCard = (plan: any) => {
    const features = language === 'ar' ? plan.features_ar : plan.features;
    const title = language === 'ar' ? plan.name_ar : plan.name;
    let valid = '';
    if (plan.period_type === "months") {
      valid = language === 'ar' ? `${plan.period} شهر` : `${plan.period} Months Plan`;
    } else {
      valid = language === 'ar' ? `${plan.period} يوم` : `${plan.period} Days Plan`;
    }

    return (
      <div className="package p-5 rounded-4 text-white" style={{ backgroundColor: '#36BD71', borderRadius: '20px', padding: '25px', margin: '10px' }}>
        <h1 className="text-uppercase fw-bold text-white mb-2" style={{ fontSize: '45px' }}>{title}</h1>
        <p className="subtitle fs-5 mb-4">{valid}</p>
        <h1 className="display-1 text-white mt-5 mb-10">$ {plan.price}</h1>
        <p className="subtitle mb-4">{featureTitle}</p>

        <div className="my-5 features">
          {features && Array.isArray(features) && features?.map((feature: string, idx: number) => (
              <p key={idx} className="fs-5 d-flex align-items-center">
                  <i className="fas fa-check me-2 text-white"></i> {feature}
              </p>
          ))}
        </div>

        {user === "Guest" ? (
          <button 
            onClick={() => alert("You need to login to Fesilah Account!")} 
            className="mt-15 btn w-100 bg-dark text-white rounded-pill fs-5 py-3"
          >
            {subscribeText}
          </button>
        ) : (
          <Link 
            to={`/subscription/cards?user_id=${userId}&plan=${plan.id}&language=${language}`}
            className="mt-15 btn w-100 bg-dark text-white rounded-pill fs-5 py-3 d-block text-center text-decoration-none"
          >
            {subscribeText}
          </Link>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="d-flex flex-column bg-base-gradient flex-center w-100 min-h-100px z-index-n1 min-h-lg-200px px-9 py-10">
        <div className="row w-100 mx-auto">
          <div className="col-md-8 mx-auto text-center">
             <h1 className={`text-dark lh-base fw-bold fs-2x ${language === 'ar' ? 'rtl' : ''}`}>{topTitle}</h1>
             <p className={`text-dark fs-3 ${language === 'ar' ? 'rtl' : ''}`}>{topDesc}</p>
          </div>
        </div>
      </div>

      <div className="z-index-2 min-h-500px inner-box mb-15 mt-5">
        <div className="container">
          
          {/* Desktop View */}
          <div className="d-none d-md-flex row justify-content-center">
            {packages && packages.map((plan: any) => (
              <div key={plan.id} className="col-md-4 col-sm-12 mb-4">
                {renderPackageCard(plan)}
              </div>
            ))}
          </div>

          {/* Mobile View (Carousel) */}
          <div className="d-block d-md-none">
            <div id="packageCarousel" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner">
                {packages && packages.map((plan: any, index: number) => (
                  <div key={plan.id} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                    {renderPackageCard(plan)}
                  </div>
                ))}
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#packageCarousel" data-bs-slide="prev" style={{filter: 'invert(1)'}}>
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#packageCarousel" data-bs-slide="next" style={{filter: 'invert(1)'}}>
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Subscription;
